export default {
  effects: {
    captions: {
      blur: 'Blur',
      crop: 'Crop',
      enhance: 'Enhance',
      flip: 'Flip',
      grayscale: 'Grayscale',
      invert: 'Invert',
      mirror: 'Mirror',
      rotate: 'Rotate',
      sharp: 'Sharpen',
    },
    apply: 'Apply',
  },
}
